<template>
    <div class="card card-custom card-stretch gutter-b d-flex">
        <div class="form_forgot-password">
            <el-container>
                <el-main>
                    <div class="pl-20 pr-20">
                        <el-card class="box-card">
                            <div class="header-form__forgot-password mb-15 mt-10">
                                <div class="title">
                                    <span class="text-dr">パスワード変更</span>
                                </div>
                            </div>
                            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-position="top"
                                     class="demo-ruleForm demo-form">
                                <div class="row mb-8">
                                    <div class="col-md-3">
                                        <h6><b>現在のパスワード</b></h6>
                                    </div>
                                    <el-form-item prop="password_old" class="col-md-9">
                                        <el-input type="password" class="bg-gray-item" v-model.lazy="ruleForm.password_old">
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="row mb-8">
                                    <div class="col-md-3">
                                        <h6><b>新規のパスワード</b></h6>
                                    </div>
                                    <el-form-item prop="password" class="col-md-9">
                                        <el-input type="password" class="bg-gray-item"  v-model.lazy="ruleForm.password">
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="row mb-8">
                                    <div class="col-md-3">
                                        <h6><b>パスワード再入力</b></h6>
                                    </div>
                                    <el-form-item prop="password_confirmation" class="col-md-9">
                                        <el-input type="password" class="bg-gray-item" v-model.lazy="ruleForm.password_confirmation">
                                        </el-input>
                                    </el-form-item>
                                </div>
                                <div class="d-flex justify-content-center mt-10">
                                    <el-button class="btn-custom" type="" @click="$router.push('top')">
                                        キャンセル
                                    </el-button>
                                    <el-button class="btn-custom" type="primary" @click="onSubmit">
                                        確定
                                    </el-button>
                                </div>
                                <input type="hidden" name="_csrf" v-model="ruleForm._csrf" />
                            </el-form>
                        </el-card>
                    </div>
                </el-main>
            </el-container>
        </div>
        <my-dialog
            v-on:submit="popup=false"
            v-bind:dialog="popup"
            :closeOnClickModal="false" width="20%" v-bind:btnOk="$t('DIALOG.BTN_OKIE_PERMISSON_DENIED')"
            :showCancelButton="false">
            <template slot="header">
                <div class="textwidget text-center">
                    {{ contentPoopup }}
                </div>
            </template>
        </my-dialog>
    </div>
</template>

<script>
import apiService from "@/core/services/api.service";
import routeTenant from "@/core/services/routeTenant.service"
import { getCsrfRandom } from "@/core/services/store/auth.module";

export default {
    name: "ForgotPassword",
    data() {
        return {
            ruleForm: {
                password_old: '',
                password: '',
                password_confirmation: '',
                _csrf:''
            },
            rules: {
            },
            sendMail: false,
            popup: false,
            contentPoopup: ''
        }
    },
    watch: {
    },
    created() {
        this.ruleForm._csrf = getCsrfRandom()
    },
    methods: {
        onSubmit() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.turnOffErrorMessage('ruleForm')
                    let data = JSON.parse(JSON.stringify(this.ruleForm))
                    apiService.post(`user/update-password-admin`, data).then(data => {
                        if (data && data.data && data.data.success) {
                            this.notifySuccess("パスワード変更が完了しました。",'')
                            this.$router.push({ name: 'subcontractor'})
                        } else if (data.data.code = 422) {
                            this.showErrorMessage(data.data.data, 'ruleForm')
                        } else {
                            this.notifyError('error server')
                        }
                    }).catch(e => {
                        this.loading = false
                        this.notifyError(e)
                    })
                }
            });
        }
    }
}
</script>

<style scoped>
.form_forgot-password {
    width: 55%;
    margin: 0 auto;
}

.header-form__forgot-password .title {
    text-align: center;
    padding: 4px 0;
    font-size: 23px;
    font-weight: bold;
}

.header-form__forgot-password .logo {
    padding: 15px;
}

.text-dr {
    color: #181C32 !important;;
}

.font-w {
    font-weight: 600;
}

.submit-form {
    font-size: 18px;
    font-weight: bold;
}
.btn-custom{
    font-weight: bold;
    font-size: 15px;
}
</style>
